import {Router} from 'react-router-dom'
import {ReactNode, createElement} from 'react'
import {memoryRouter} from '@bakkt/components'

export const MemoryRouter = ({children}: {children?: ReactNode}) => createElement(Router, memoryRouter({children}))
